import {
  DataTable,
  DataTableColumn,
  DataTableOptions,
  DataType,
  SelectOption,
  UserPermission
} from '@globaleris/ui.library'
import React from 'react'
import { useTranslation } from 'react-i18next'
import { getCustomerDomain } from '../../../../redux'
import { AttachedDocumentFile } from '../../procedures.types'
import { AttachedFilesEmptyCard } from './attachedFilesEmptyCard'
import { Edit, Delete } from '@material-ui/icons'

export const AttachedFilesTable = ({
  files,
  documentsTypes,
  onClickAddButton,
  onClickDeleteButton
}: {
  files: AttachedDocumentFile[]
  documentsTypes: SelectOption[]
  onClickAddButton: () => void
  onClickDeleteButton: (document: AttachedDocumentFile) => void
}) => {
  const [t] = useTranslation(['documents', 'globalerisLibrary', 'enums'])

  const dataTableColumns: DataTableColumn[] = [
    {
      name: 'type',
      label: t('procedures:components.attachedFilesTable.columns.type'),
      type: DataType.SELECT,
      selectOptions: documentsTypes,
      required: true,
      inputSize: 4
    },
    {
      name: 'description',
      label: t('procedures:components.attachedFilesTable.columns.description'),
      type: DataType.TEXT,
      required: true,
      inputSize: 4
    },
    {
      name: 'comments',
      label: t('procedures:components.attachedFilesTable.columns.comments'),
      type: DataType.TEXT,
      inputSize: 4
    },
    {
      name: 'content.name',
      label: t('procedures:components.attachedFilesTable.columns.fileName'),
      type: DataType.TEXT,
      inputSize: 4
    }
  ]

  const dataTableOptions: DataTableOptions = {
    i18n: t('globalerisLibrary:dataTable', { returnObjects: true }),
    // search: !cardMode,
    elevation: 4,
    // filterType: !cardMode ? FilterType.ADVANCED : undefined,
    // download: !cardMode,
    canEdit: false,
    canDelete: false,
    canInsert: true,
    selectableRows: false,
    customInsertEditModal: true,
    analytics: {
      customer: getCustomerDomain(),
      view: t('procedures:components.attachedFilesTable.analytics')
    },
    onRowInsert: async () => {
      onClickAddButton()
      return true
    },
    rowCustomActions: [
      // {
      //   userPermission: UserPermission.EDIT,
      //   icon: <Edit fontSize="small" />,
      //   tooltip: t('priceCoefficient:dataTable.customActions.editValue.tooltip'),
      //   onClick: (row: any) => {
      //     // onEditValuesActionHandler(row)
      //   }
      // },
      {
        userPermission: UserPermission.EDIT,
        icon: <Delete fontSize="small" />,
        tooltip: t('procedures:components.attachedFilesTable.actions.delete'),
        onClick: (row: AttachedDocumentFile) => onClickDeleteButton(row)
      }
    ]
  }

  return files && files.length > 0 ? (
    <DataTable
      data={files}
      columns={dataTableColumns}
      options={dataTableOptions}
      subtitle={t('procedures:components.attachedFilesTable.title')}
      // info={DataTableErrorHandler(errorProps)}
    />
  ) : (
    <AttachedFilesEmptyCard
      onClick={onClickAddButton}
      buttonDisabled={documentsTypes?.length === 0}
    />
  )
}
